var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93164 13.1563H3.3125C3.18818 13.1563 3.06895 13.1069 2.98105 13.019C2.89314 12.9311 2.84375 12.8119 2.84375 12.6876V10.0684C2.84354 10.0076 2.85533 9.94725 2.87846 9.89095C2.90158 9.83464 2.93558 9.78345 2.97852 9.74031L10.0098 2.70906C10.0534 2.66477 10.1054 2.62959 10.1627 2.60559C10.2201 2.58158 10.2816 2.56921 10.3438 2.56921C10.4059 2.56921 10.4675 2.58158 10.5248 2.60559C10.5821 2.62959 10.6341 2.66477 10.6777 2.70906L13.291 5.32234C13.3353 5.36595 13.3705 5.41794 13.3945 5.47528C13.4185 5.53262 13.4309 5.59416 13.4309 5.65632C13.4309 5.71848 13.4185 5.78002 13.3945 5.83736C13.3705 5.8947 13.3353 5.94669 13.291 5.99031L6.25977 13.0216C6.21662 13.0645 6.16543 13.0985 6.10913 13.1216C6.05282 13.1447 5.99251 13.1565 5.93164 13.1563V13.1563Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46875 4.25L11.75 7.53125",
    stroke: "#6D6D6D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.0d2e2c98d889558ec69564fb6869b44b.svg";
export { ForwardRef as ReactComponent };